// extracted by mini-css-extract-plugin
export default {"Emojis__item":"bfi_a bhh_wh bhh_sq bhh_xj"};